var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageContent",attrs:{"id":"app"}},[_c('k-loading'),_c('k-black-screen'),_c('router-view'),_c('update-version-modal',{ref:"updateVersionModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }